"use strict";
/** Discovery Quality Scoring shared types (TASK-4 — FR-2+FR-4+FR-5) */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RALLY_ACTIVITY_WINDOW_MS = exports.RALLY_ACTIVITY_WINDOW_DAYS = void 0;
/**
 * The Rally activity window: a Feature is "active" if it was updated within
 * this many ms. `rally-feature-discovery` (rally-client.ts) and the read-time
 * staleness check must treat a Feature as active/inactive identically, so this
 * lives once here and both sides import it rather than each re-literaling the
 * arithmetic.
 *
 * 30 days, narrowed from 60 (2026-08-20). Two reasons, in order of weight:
 *
 *  1. **Signal.** Discovery maturity is a statement about how a team works
 *     *now*; a Feature untouched for two months is weak evidence of current
 *     practice. Measured over 1,910 scored prod Features, 65.5% were updated
 *     within 30 days and 32.1% fell in the 31-60 day band — so the wider window
 *     was diluting each team's average with a third of its mass sitting on
 *     stale evidence.
 *  2. **Cost.** Every scored Feature is a Bedrock call (~$0.065 measured across
 *     two full prod Release Train sweeps). At ~21.5 Features per leaf team over
 *     1,036 leaves, a cold estate sweep is ~22k Features / ~$1,450 at 60 days
 *     versus ~14.6k / ~$950 at 30 — and that delta recurs on every
 *     `CURRENT_DISCOVERY_RUBRIC_VERSION` bump, since a bump forces a global
 *     cache miss by design.
 *
 * Changing this shifts every team's score (a third of the Feature mass leaves
 * the average) and makes pre/post history non-comparable, so it is a rubric
 * decision, not a tuning knob. If it changes again, bump
 * `CURRENT_DISCOVERY_RUBRIC_VERSION` in `rubric.ts` so cached scores from the
 * old window are not silently blended with the new one.
 */
exports.RALLY_ACTIVITY_WINDOW_DAYS = 30;
exports.RALLY_ACTIVITY_WINDOW_MS = exports.RALLY_ACTIVITY_WINDOW_DAYS * 24 * 60 * 60 * 1000;
//# sourceMappingURL=discovery.js.map